export default "__VITE_ASSET__B4rmiIBD__"